import { ButtonAnimator } from "@cc/pixi-app";

/**
 */
export class TapAnimation extends ButtonAnimator {
  /**
   */
  constructor() {
    super();
  }

  /**
   * @param {Container} target
   * @param {Function} resolve
   */
  play(target, resolve) {
    const duration = 66;
    target.scale.set(1);
    createjs.Tween.get(target.scale)
      .to({ x: 0.9, y: 0.9 }, duration)
      .to({ x: 1, y: 1 }, duration)
      .call(resolve);
  }
}
